var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/Users/nam.phamanh/Documents/Nam/git/cs/lazada/node_modules/_nunjucks-loader@2.4.9@nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/app/module/topOrder/tpl.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"m-plugin-toporder\">\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "list")),"length")) {
output += "\n    <div class=\"order-container\"></div>\n    <div class=\"btn\">\n      <a href=\"#\" data-action=\"listOrderMore\" class=\"J_AllItem listOrderMore\">\n        全部宝贝\n        <svg class=\"icon\" aria-hidden=\"true\">\n          <use xlink:href=\"#icon-arrow_next\"></use>\n        </svg>\n      </a>\n    </div>\n    ";
;
}
else {
output += "\n    <div class=\"no-order\">\n      <img src=\"//gw.alicdn.com/tps/TB1SjpmMpXXXXcRXpXXXXXXXXXX-249-280.png\" alt=\"\" class=\"bee\">\n      <div class=\"text\">\n        亲，你还没有宝贝哦～\n        <svg class=\"icon\" aria-hidden=\"true\">\n          <use xlink:href=\"#icon-arrow_next\"></use>\n        </svg>\n      </div>\n    </div>\n    ";
;
}
output += "\n</div>\n\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/app/module/topOrder/tpl.html"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./src/app/module/topOrder/tpl.html
// module id = 305
// module chunks = 0 1